import React from "react";
import PropTypes from "prop-types";
import { formatPhoneNumber } from "./fieldUtils";
import LabelAndDots from "./LabelAndDots";

const PhoneField = ({
  field,
  formData,
  handleChange,
  readOnly,
  validationErrors,
}) => {
  const isFieldReadOnly = readOnly || field.key === "managementId";
  const errorClass = validationErrors[field.key] ? "border border-red-500" : "";

  const handlePhoneInputChange = (e) => {
    const rawValue = e.target.value;
    const digitsOnly = rawValue.replace(/\D/g, "");
    const limitedDigits = digitsOnly.slice(0, 14);
    handleChange({
      target: {
        name: field.key,
        value: limitedDigits,
      },
    });
  };

  return (
    <div className="flex flex-col w-full">
      <div className="flex items-center w-full">
        <label
          className="flex items-center text-sm"
          style={{
            lineHeight: "1.2",
            whiteSpace: "nowrap",
            overflow: "hidden",
            width: "12.5em",
          }}
        >
          <LabelAndDots
            label={field.label}
            tooltip={field.tooltip}
            required={field.required && !!validationErrors[field.key]}
          />
        </label>
        <input
          name={field.key}
          type="text"
          className={`text-sm p-1 flex-grow size-7 ${errorClass} ${
            isFieldReadOnly
              ? "bg-gray-100 cursor-not-allowed"
              : "border border-gray-700"
          }`}
          value={formatPhoneNumber(formData[field.key] || "")}
          onChange={handlePhoneInputChange}
          readOnly={isFieldReadOnly}
          style={
            isFieldReadOnly ? { pointerEvents: "none", userSelect: "none" } : {}
          }
        />
      </div>
      {validationErrors[field.key] && (
        <div className="text-red-500 text-sm mt-1 text-end">
          {validationErrors[field.key]}
        </div>
      )}
    </div>
  );
};

PhoneField.propTypes = {
  field: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  validationErrors: PropTypes.object,
};

export default PhoneField;
